/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Hotel_Lobby_CreditsInputs */

const en_admin_settings_fields_hotel_lobby_credits = /** @type {(inputs: Admin_Settings_Fields_Hotel_Lobby_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits per video (override)`)
};

/**
* | output |
* | --- |
* | "Credits per video (override)" |
*
* @param {Admin_Settings_Fields_Hotel_Lobby_CreditsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_hotel_lobby_credits = /** @type {((inputs?: Admin_Settings_Fields_Hotel_Lobby_CreditsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Hotel_Lobby_CreditsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_hotel_lobby_credits(inputs)
});
export { admin_settings_fields_hotel_lobby_credits as "admin.settings.fields.hotel_lobby_credits" }